<template>
    <div class="mt-6 gap-1 flex items-center justify-center">
        <button
            v-for="locale in locales"
            :key="locale.value"
            type="button"
            class="rounded-md px-2 py-1 text-sm font-medium transition"
            :class="
                locale.value === currentLocale
                    ? 'bg-iron-100 text-iron-900'
                    : 'text-iron-500 hover:text-iron-900'
            "
            :aria-current="locale.value === currentLocale ? 'true' : undefined"
            @click="switchTo(locale.value)"
        >
            {{ locale.label }}
        </button>
    </div>
</template>

<script lang="ts" setup>
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";

const locales = [
    { value: "en-US", label: "English" },
    { value: "cs-CZ", label: "Čeština" },
];

const page = usePage();

const currentLocale = computed(() =>
    page.props.locale === "cs-CZ" ? "cs-CZ" : "en-US",
);

/**
 * Translations are bootstrapped once from the initial Inertia page props,
 * so switching the language needs a full page load, not an Inertia visit.
 */
function switchTo(locale: string): void {
    if (locale === currentLocale.value) {
        return;
    }

    const url = new URL(window.location.href);

    if (locale === "cs-CZ") {
        url.searchParams.set("locale", "cs-CZ");
    } else {
        url.searchParams.delete("locale");
    }

    window.location.href = url.toString();
}
</script>
